<template>
    <div class="center-page">
        <img src="./../../assets/img/ss1.png" alt="">
        <el-form label-width="120px" label-position="right">
            <el-form-item label="客服微信："><span class="f-20 color-red fw-b">{{serviceInfo.tel}}</span></el-form-item>
            <el-form-item label="QQ客服："><span class="f-20 color-red fw-b">{{serviceInfo.qq}}</span></el-form-item>
            <el-form-item label="电子邮箱："><span class="f-20 color-red fw-b">{{serviceInfo.mail}}</span></el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "contactService",
        data() {
            return {
                key: ''
            }
        },
        computed:{
            ...mapState(['serviceInfo'])
        },
        created() {
        },
        methods: {
            name() {

            }
        },
    }
</script>

<style scoped lang="less">
    .center-page{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
</style>
